/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ParentWorkItemContext } from './ParentWorkItemContext';
import {
    ParentWorkItemContextFromJSON,
    ParentWorkItemContextFromJSONTyped,
    ParentWorkItemContextToJSON,
} from './ParentWorkItemContext';
import type { WorkItemComment } from './WorkItemComment';
import {
    WorkItemCommentFromJSON,
    WorkItemCommentFromJSONTyped,
    WorkItemCommentToJSON,
} from './WorkItemComment';

/**
 * 
 * @export
 * @interface WorkItemContext
 */
export interface WorkItemContext {
    /**
     * 
     * @type {string}
     * @memberof WorkItemContext
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkItemContext
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkItemContext
     */
    acceptanceCriteria?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkItemContext
     */
    meetingTranscription?: string;
    /**
     * 
     * @type {ParentWorkItemContext}
     * @memberof WorkItemContext
     */
    parentContext?: ParentWorkItemContext;
    /**
     * 
     * @type {Array<WorkItemComment>}
     * @memberof WorkItemContext
     */
    comments?: Array<WorkItemComment>;
}

/**
 * Check if a given object implements the WorkItemContext interface.
 */
export function instanceOfWorkItemContext(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WorkItemContextFromJSON(json: any): WorkItemContext {
    return WorkItemContextFromJSONTyped(json, false);
}

export function WorkItemContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkItemContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'acceptanceCriteria': !exists(json, 'acceptanceCriteria') ? undefined : json['acceptanceCriteria'],
        'meetingTranscription': !exists(json, 'meetingTranscription') ? undefined : json['meetingTranscription'],
        'parentContext': !exists(json, 'parentContext') ? undefined : ParentWorkItemContextFromJSON(json['parentContext']),
        'comments': !exists(json, 'comments') ? undefined : ((json['comments'] as Array<any>).map(WorkItemCommentFromJSON)),
    };
}

export function WorkItemContextToJSON(value?: WorkItemContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'description': value.description,
        'acceptanceCriteria': value.acceptanceCriteria,
        'meetingTranscription': value.meetingTranscription,
        'parentContext': ParentWorkItemContextToJSON(value.parentContext),
        'comments': value.comments === undefined ? undefined : ((value.comments as Array<any>).map(WorkItemCommentToJSON)),
    };
}

